const { Type } = require('@sinclair/typebox');
const Blockly = require('blockly');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');
const convertToBoolean = require('../../../../helpers/convertToBoolean');

const TOOLTIP = 'Display a link from specified title and url properties';

function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    blocklyBlock.setTooltip(TOOLTIP);
    //set inputs to be arranged horizontally (this is the default)
    //Meaning each (dummy)input continues on the top line followed by  the access modifiers
    blocklyBlock.setInputsInline(false);
    line1OfInputs.appendField('  Title Property:').appendField(new Blockly.FieldTextInput('title'), 'propertyName');
    line1OfInputs.appendField('  URL Property:').appendField(new Blockly.FieldTextInput('url'), 'propertyUrl');
    line1OfInputs
        .appendField('  Open in new Window:')
        .appendField(new Blockly.FieldCheckbox('TRUE'), 'openInNewWindow');
}

function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties(['propertyName', 'propertyUrl', { key: 'openInNewWindow', handler: convertToBoolean }]);

    code.label = code.title;
    code.dataType = 'link';
    return code;
}

/** Builds the data dictionary fragment for the Link list column. */
function asDataDictionary(hNode, context) {
    const { propertyName, propertyUrl } = hNode;

    // Create TypeBox string schema for the title property
    const titleSchema = Type.Optional(
        Type.String({
            title: 'Filename',
            'x-dataType': 'string',
            'x-propertyName': propertyName,
            'x-optional': true,
            'x-required': false
        })
    );

    // Create TypeBox string schema for the URL property
    const urlSchema = Type.Optional(
        Type.String({
            title: 'URL',
            'x-dataType': 'string',
            'x-propertyName': propertyUrl,
            'x-optional': true,
            'x-required': false
        })
    );

    //we know this data type (whatever it is), has at least these 2 properties
    const partialTypeDefinition = {
        [propertyName]: titleSchema,
        [propertyUrl]: urlSchema
    };

    //And the given foreignKey exists on the parent object.
    return [{}, partialTypeDefinition];
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode, asDataDictionary };
